var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useLayoutEffect } from "react";
import useAsync from "react-use/lib/useAsync";
export var CloudStreamConnectionState;
(function (CloudStreamConnectionState) {
    CloudStreamConnectionState[CloudStreamConnectionState["Disconnected"] = 0] = "Disconnected";
    CloudStreamConnectionState[CloudStreamConnectionState["Ready"] = 1] = "Ready";
    CloudStreamConnectionState[CloudStreamConnectionState["Connecting"] = 2] = "Connecting";
    CloudStreamConnectionState[CloudStreamConnectionState["ConnectionError"] = 3] = "ConnectionError";
    CloudStreamConnectionState[CloudStreamConnectionState["ChangingMode"] = 4] = "ChangingMode";
})(CloudStreamConnectionState || (CloudStreamConnectionState = {}));
export const CloudStreamContext = React.createContext(undefined);
export const CloudStreamOptionsContext = React.createContext(undefined);
export const CloudStreamStateContext = React.createContext(CloudStreamConnectionState.Disconnected);
export function CloudStream(props) {
    const cloudstream = useAsync(() => __awaiter(this, void 0, void 0, function* () { return props.cloudstream instanceof Promise ? yield props.cloudstream : props.cloudstream; }), [props.cloudstream]);
    const options = useAsync(() => __awaiter(this, void 0, void 0, function* () { return props.options instanceof Promise ? yield props.options : props.options; }), [props.options]);
    function disconnect() {
        var _a;
        (_a = cloudstream.value) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    useEffect(() => disconnect, [cloudstream.value, options.value]);
    useEffect(() => {
        (props.connect && cloudstream.value && options.value) ? cloudstream.value.connect(options.value) : undefined;
    }, [cloudstream.value, options.value, props.connect]);
    useLayoutEffect(() => {
        const cs = cloudstream.value;
        return cs ?
            (window.addEventListener("beforeunload", disconnect),
                () => window.removeEventListener("beforeunload", disconnect)) : undefined;
    }, [cloudstream.value]);
    return (React.createElement(CloudStreamContext.Provider, { value: cloudstream.value },
        React.createElement(CloudStreamOptionsContext.Provider, { value: options.value },
            React.createElement(CloudStreamState, null, props.children))));
}
export function CloudStreamState(props) {
    const cloudstream = useCloudStream();
    const [ready, setReady] = React.useState(CloudStreamConnectionState.Disconnected);
    function onReady() {
        setReady(CloudStreamConnectionState.Ready);
    }
    function onDisconnect() {
        setReady(CloudStreamConnectionState.Disconnected);
    }
    function onConnect() {
        setReady(CloudStreamConnectionState.Connecting);
    }
    function onConnectionError() {
        setReady(CloudStreamConnectionState.ConnectionError);
    }
    useEffect(() => {
        cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.addEventListener("streamReady", onReady);
        cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.addEventListener("streamDisconnect", onDisconnect);
        cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.addEventListener("streamConnect", onConnect);
        cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.addEventListener("streamConnectFailed", onConnectionError);
        cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.addEventListener("error", onConnectionError);
        return () => {
            cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.removeEventListener("streamReady", onReady);
            cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.removeEventListener("streamDisconnect", onDisconnect);
            cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.removeEventListener("streamConnect", onConnect);
            cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.removeEventListener("streamConnectFailed", onConnectionError);
            cloudstream === null || cloudstream === void 0 ? void 0 : cloudstream.removeEventListener("error", onConnectionError);
        };
    }, [cloudstream]);
    return (React.createElement(CloudStreamStateContext.Provider, { value: ready }, props.children));
}
export function useCloudStream() {
    return useContext(CloudStreamContext);
}
export function useCloudStreamOptions() {
    return useContext(CloudStreamOptionsContext);
}
export function useCloudStreamState() {
    return useContext(CloudStreamStateContext);
}
